import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const StackedColumnChart = ({ cutSeg, fillSeg, cutPoly, fillPoly }) => {
    const options = {
        chart: {
            type: 'column',
            backgroundColor: 'rgb(33, 37, 41)' // optional dark background
        },
        title: {
            text: 'Volume Segments',
            style: {
                color: '#ffffff'
            }
        },
        xAxis: {
            categories: ['Seg Vol', 'Poly Vol'],
            labels: {
                style: {
                    color: '#ffffff'
                }
            }
        },
        yAxis: {
            min: -10000,
            title: {
                text: 'Total Volumes',
                style: {
                    color: '#ffffff'
                }
            },
            labels: {
                style: {
                    color: '#ffffff'
                }
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: '#ffffff'
                },
                formatter: function () {
                    return `Total: ${this.total?.toFixed(2)} m³`;
                }
            }
        },
        legend: {
            itemStyle: {
                color: '#ffffff'
            }
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
            style: {
                color: 'black'
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    style: {
                        color: '#ffffff'
                    }
                }
            }
        },
        series: [{
            name: 'Fill',
            data: [parseFloat(fillSeg), parseFloat(fillPoly)]
        }, {
            name: 'Cut',
            data: [parseFloat(cutSeg), parseFloat(cutPoly)]
        }]
    };

    return <div>
        <div className='text-light mt-3'>Segment Volumes</div>
        <table className='text-light table table-dark align-start'>
            <tbody className='align-middle'>
                <tr style={{textAlign:"start"}}>
                    <td className='text-success' style={{ fontSize: 12 }}>Volume of Entire Segment</td>
                    <td className='text-primary'>{(parseFloat(fillSeg) + parseFloat(cutSeg)).toFixed(4)}m&sup3;</td>
                </tr>
                <tr style={{textAlign:"start"}}>
                    <td className='text-success' style={{ fontSize: 12 }}>Volume of Polygon</td>
                    <td className='text-primary'>{(parseFloat(fillPoly) + parseFloat(cutPoly)).toFixed(4)}m&sup3;</td>
                </tr>
            </tbody>
        </table>
    </div>

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default StackedColumnChart;
